import React, { useState, useEffect, useContext } from 'react';
import { Container, Stack, Grid, Chip, Divider, Box, FormControl, TextField, Button, Card, CardContent, Typography, CircularProgress, IconButton, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";
import axios from 'axios';
import { ContextSession } from "../../../services/ContextSession";
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ErrorIcon from '@mui/icons-material/Error';

function ActualizarCorreos() {
    let sessi = useContext(ContextSession);
    const [valor, setValor] = useState('');
    const [datos, setDatos] = useState(null);
    const [error, setError] = useState('');
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [identidadConsultada, setIdentidadConsultada] = useState('');
    const [dialogOpen, setDialogOpen] = useState(false);
    const [dialogMessage, setDialogMessage] = useState('');
    const [nuevoCorreo, setNuevoCorreo] = useState('');
    const [confirmarNuevoCorreo, setConfirmarNuevoCorreo] = useState('');
    const [nuevoCorreoError, setNuevoCorreoError] = useState(false);
    const [nuevoCorreoHelperText, setNuevoCorreoHelperText] = useState('');
    const [confirmarCorreoError, setConfirmarCorreoError] = useState(false);
    const [confirmarCorreoHelperText, setConfirmarCorreoHelperText] = useState('');
    const [dialogTitle, setDialogTitle] = useState('Información');
    const [dialogIcon, setDialogIcon] = useState(null);

    const handleChange = (event) => {
        const valorIngresado = event.target.value;
        const regex = /^[0-9]+$/; // Solo números

        if (regex.test(valorIngresado)) {
            setValor(valorIngresado);
        } else {
            setValor(''); // o puedes mostrar un error
        }
    };

    const consultarAPI = async () => {
        setLoading(true); // Comienza la carga
        try {
            const response = await axios.post('https://bei360.injupemp.gob.hn:8444/api/datos/biometria', {
                dni: valor
            });

            if (response.data.error) {
                setError(response.data.error);
                setDatos(null);
            } else {
                const informacion = response.data.informacion;

                // Validar que informacion no sea null o undefined
                if (!informacion) {
                    setError('No se recibió información válida de la API');
                    setDatos(null);
                } else {
                    const nuevosDatos = {
                        nombre: `${informacion[0]?.split(': ')[1] ?? ''} ${informacion[1]?.split(': ')[1] ?? ''} ${informacion[2]?.split(': ')[1] ?? ''} ${informacion[3]?.split(': ')[1] ?? ''}`,
                        nacimiento: informacion[4]?.split(': ')[1] ?? '',
                        direccion: informacion[5]?.split(': ')[1] ?? '',
                        telefono: informacion[7]?.split(': ')[1] ?? '',
                        telefonotrabajo: informacion[8]?.split(': ')[1] ?? '',
                        correo: informacion[9]?.split(': ')[1] ?? '',
                        direcciontrabajo: informacion[10]?.split(': ')[1] ?? '',
                        area: informacion[11]?.split(': ')[1] ?? '',
                        fechacreacion: informacion[12]?.split(': ')[1] ?? '',
                        fecharegistro: informacion[13]?.split(': ')[1] ?? '',
                        departamento: informacion[14]?.split(': ')[1] ?? '',
                        municipio: informacion[15]?.split(': ')[1] ?? '',
                        colonia: informacion[16]?.split(': ')[1] ?? '',
                        estadocivil: informacion[17]?.split(': ')[1] ?? '',
                        nacionalidad: informacion[19]?.split(': ')[1] ?? '',
                        sexo: informacion[18]?.split(': ')[1] ?? '',
                        pais: informacion[20]?.split(': ')[1] ?? '',
                        profesion: informacion[21]?.split(': ')[1] ?? ''
                    };

                    setDatos(nuevosDatos);
                    setIdentidadConsultada(valor);
                    setError('');
                }
            }
            setVisible(true);
        } catch (error) {
            setError('No se encontró información válida para el DNI proporcionado');
            setVisible(true);
        }
        setLoading(false); // Termina la carga
    };

    const actualizarDatos = async () => {
        // Limpiar errores previos
        setNuevoCorreoError(false);
        setConfirmarCorreoError(false);
        setNuevoCorreoHelperText('');
        setConfirmarCorreoHelperText('');

        // Verificar que los campos no estén vacíos
        if (!nuevoCorreo.trim() || !confirmarNuevoCorreo.trim()) {
            if (!nuevoCorreo.trim()) {
                setNuevoCorreoError(true);
                setNuevoCorreoHelperText('Este campo es obligatorio.');
            }
            if (!confirmarNuevoCorreo.trim()) {
                setConfirmarCorreoError(true);
                setConfirmarCorreoHelperText('Este campo es obligatorio.');
            }
            return;
        }

        // Verificar formato de los correos
        const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        if (!emailRegex.test(nuevoCorreo)) {
            setNuevoCorreoError(true);
            setNuevoCorreoHelperText('El formato del correo no es válido.');
            return;
        }

        if (!emailRegex.test(confirmarNuevoCorreo)) {
            setConfirmarCorreoError(true);
            setConfirmarCorreoHelperText('El formato del correo no es válido.');
            return;
        }

        // Verificar que los correos coincidan
        if (nuevoCorreo !== confirmarNuevoCorreo) {
            setConfirmarCorreoError(true);
            setConfirmarCorreoHelperText('Los correos no coinciden.');
            return;
        }

        // Enviar datos a la API si las validaciones son correctas
        try {
            setLoading(true);  // Activar indicador de carga

            // Preparar los datos para enviar
            const formData = new FormData();
            formData.append('dni', identidadConsultada);
            formData.append('nombre', datos.nombre); // Asegúrate que 'datos.nombre' esté definido
            formData.append('correoNuevo', nuevoCorreo);
            formData.append('IdUsuarioVerificado', sessi.sessionData.id);

            // Configurar los encabezados con el Access token
            const config = {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    'Authorization': `Bearer ${sessi.sessionData.token}`,  // Access Token
                }
            };

            // Realizar la solicitud POST
            const response = await axios.post('https://be.injupemp.gob.hn:8443/api/cambioCorreoPrestamos/', formData, config);

            // Verificar el statusCode 201 para confirmar que los datos fueron creados correctamente
            if (response.status === 201) {
                setDialogMessage('El correo fue actualizado correctamente.');
                setDialogOpen(true);
                setDialogTitle('Datos Enviados');
                setDialogIcon(<CheckCircleIcon sx={{ color: 'green' }} />);
            } else {
                // Si no es 201, mostrar un mensaje genérico de error
                setDialogMessage('Ocurrió un error al actualizar los datos.');
                setDialogOpen(true);
                setDialogTitle('Error');
                setDialogIcon(<ErrorIcon sx={{ color: 'red' }} />);
            }
        } catch (error) {
            // Manejar errores de la solicitud
            setDialogMessage('Ocurrió un error al comunicarse con el servidor.');
            setDialogOpen(true);
            setDialogTitle('Error');
            setDialogIcon(<ErrorIcon sx={{ color: 'red' }} />);
        } finally {
            setLoading(false);  // Desactivar el indicador de carga
        }

        // Reseteamos los campos
        setNuevoCorreo('');
        setConfirmarNuevoCorreo('');
        setVisible(false);
        setIdentidadConsultada('');
        setValor('');
    };



    return (
        <>
            <Container>
                <Card sx={{ maxWidth: 800, margin: 'auto', padding: 1, borderRadius: 2, boxShadow: 3, marginTop: 5 }}>
                    <CardContent>
                        <Stack direction="row" spacing={2} alignItems="center" textAlign={"center"} justifyContent="center" sx={{ marginBottom: 3 }}>
                            <ManageAccountsIcon sx={{ fontSize: 50 }} />
                            <Typography variant="h5" component="h2" fontWeight="bold">
                                Actualizar Correos Electrónicos de Participantes Afiliados
                            </Typography>
                        </Stack>

                        <Stack direction="column" spacing={3} alignItems="center" sx={{ marginTop: 2 }}>
                            {/* Divider con Chip arriba del TextField */}
                            <Divider sx={{ width: '100%' }}>
                                <Chip label="INGRESE EL NÚMERO DE IDENTIDAD DEL PARTICIPANTE" size="medium" sx={{ fontWeight: 'bold' }} />
                            </Divider>

                            {/* Stack para el formulario y el botón */}
                            <Stack direction="row" spacing={3} justifyContent="center" alignItems="center">
                                <FormControl sx={{ width: 250 }}>
                                    <TextField
                                        id="NumeroIdentidad"
                                        label="Número de Identidad"
                                        placeholder="Identidad sin espacios ni guiones"
                                        variant="filled"
                                        value={valor}
                                        onChange={handleChange}
                                        inputProps={{ maxLength: 13 }}
                                        fullWidth
                                    />
                                </FormControl>

                                <Button
                                    variant="contained"
                                    sx={{
                                        backgroundColor: '#AD8401',
                                        '&:hover': {
                                            backgroundColor: '#19438C',
                                            color: 'white',
                                        },
                                    }}
                                    onClick={consultarAPI}
                                    disabled={valor.length !== 13} // Deshabilitar si no tiene 13 dígitos
                                >
                                    Consultar
                                </Button>
                            </Stack>
                        </Stack>
                    </CardContent>
                </Card>

                {loading && (
                    <Box display="flex" justifyContent="center" marginTop={2}>
                        <CircularProgress />
                    </Box>
                )}

                {visible && (
                    <>
                        <Divider style={{ marginTop: 20 }}>
                            <Chip
                                label="DATOS DEL ENROLAMIENTO"
                                size="medium"
                                sx={{ fontWeight: 'bold' }} // Aplica negrita al texto del Chip
                            />
                        </Divider>

                        <div id="my-container">
                            <Box marginTop={2} boxShadow={3}>
                                <Card variant='elevation'>
                                    <CardContent>
                                        {error ? (
                                            <>
                                                <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                    <img src={process.env.PUBLIC_URL + '/error.jpg'} alt="Error" style={{ marginRight: 10, width: 130, height: 130 }} />
                                                    <Typography color="error" style={{ flexGrow: 1, textAlign: 'center' }}>{error}</Typography>
                                                </Box>
                                            </>
                                        ) : (
                                            <>
                                                <Stack direction="row">
                                                    <Grid container spacing={0}>
                                                        <FormControl sx={{ m: 1, flexGrow: 2 }}>
                                                            <TextField
                                                                id="nombre"
                                                                label="Nombre Completo"
                                                                variant="filled"
                                                                InputProps={{ readOnly: true }}
                                                                size="small"
                                                                value={datos.nombre}
                                                            />
                                                        </FormControl>
                                                        <FormControl sx={{ m: 1, flexGrow: 1 }}>
                                                            <TextField
                                                                id="telefono"
                                                                label="Teléfono Móvil"
                                                                variant="filled"
                                                                InputProps={{ readOnly: true }}
                                                                size="small"
                                                                value={datos.telefono}
                                                            />
                                                        </FormControl>
                                                        <FormControl sx={{ m: 1, flexGrow: 2 }}>
                                                            <TextField
                                                                id="correo"
                                                                label="Correo"
                                                                variant="filled"
                                                                InputProps={{ readOnly: true }}
                                                                size="small"
                                                                value={datos.correo}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                </Stack>
                                            </>
                                        )}
                                    </CardContent>
                                </Card>
                            </Box>

                        </div>
                    </>
                )}

                {visible && (
                    <>
                        <Divider style={{ marginTop: 30 }}>
                            <Chip
                                label="INGRESAR NUEVO CORREO"
                                size="medium"
                                sx={{ fontWeight: 'bold' }} // Aplica negrita al texto del Chip
                            />
                        </Divider>

                        <div id="my-container">
                            <Box marginTop={2} boxShadow={3}>
                                <Card variant='elevation'>
                                    <CardContent>
                                        {error ? (
                                            <>
                                                <Box style={{ display: 'flex', alignItems: 'center' }}>
                                                    <img src={process.env.PUBLIC_URL + '/error.jpg'} alt="Error" style={{ marginRight: 10, width: 130, height: 130 }} />
                                                    <Typography color="error" style={{ flexGrow: 1, textAlign: 'center' }}>{error}</Typography>
                                                </Box>
                                            </>
                                        ) : (
                                            <>
                                                <Stack direction="row">
                                                    <Grid container spacing={0}>
                                                        <FormControl sx={{ m: 1, flexGrow: 2 }}>
                                                            <TextField
                                                                id="nuevoCorreo"
                                                                label="Nuevo Correo"
                                                                variant="outlined"
                                                                value={nuevoCorreo}
                                                                onChange={(e) => setNuevoCorreo(e.target.value)}
                                                                error={nuevoCorreoError}
                                                                helperText={nuevoCorreoHelperText}
                                                            />
                                                        </FormControl>
                                                        <FormControl sx={{ m: 1, flexGrow: 2 }}>
                                                            <TextField
                                                                id="confirmarNuevoCorreo"
                                                                label="Confirmar Nuevo Correo"
                                                                variant="outlined"
                                                                value={confirmarNuevoCorreo}
                                                                onChange={(e) => setConfirmarNuevoCorreo(e.target.value)}
                                                                error={confirmarCorreoError}
                                                                helperText={confirmarCorreoHelperText}
                                                            />
                                                        </FormControl>
                                                    </Grid>
                                                </Stack>
                                            </>
                                        )}
                                    </CardContent>
                                </Card>
                            </Box>

                            <Box marginTop={5} textAlign="center">
                                <Button
                                    variant="contained"
                                    sx={{
                                        backgroundColor: '#19438C',
                                        color: 'white',
                                        '&:hover': {
                                            backgroundColor: '#AD8401',
                                            color: 'black'
                                        },
                                    }}
                                    onClick={actualizarDatos}
                                >
                                    Actualizar Datos
                                </Button>
                            </Box>
                        </div>
                    </>
                )}

                <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)}>
                    <DialogTitle sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                            {dialogIcon && (
                                <Box sx={{ marginRight: 1, fontSize: '2rem' }}> {/* Aumenta el tamaño del ícono aquí */}
                                    {dialogIcon}
                                </Box>
                            )}
                            <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                                {dialogTitle}
                            </Typography>
                        </Box>
                    </DialogTitle>

                    <DialogContent>
                        <DialogContentText textAlign={'justify'}>
                            {dialogMessage}
                        </DialogContentText>
                    </DialogContent>

                    <DialogActions>
                        <Box display="flex" justifyContent="center" width="100%">
                            <Button
                                onClick={() => setDialogOpen(false)}
                                variant="contained"
                                sx={{
                                    backgroundColor: '#19438C',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: '#FF0000',
                                        color: 'white'
                                    },
                                }}
                            >
                                Cerrar
                            </Button>
                        </Box>
                    </DialogActions>
                </Dialog>


            </Container>
        </>
    );
}

export default ActualizarCorreos;
